import { PortCall, PortCallOptions } from 'data/models/PortCall';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type PortCallPITOptions = ReqChangeId<PortCallOptions>;
export const PortCallPITKey = makePITKey<PortCall>(PortCall.key);
export const PortCallPITDataKey = makePITDataKey<PortCallOptions>(PortCall.dataKey);



// WEBPACK FOOTER //
// ./data/models/PortCallPIT.ts